import {setInstance} from '@/helper/Axios';

export default function ({$axios}) {
  setInstance($axios);
}
